/* eslint-disable import/no-cycle */

import { capitalizeFirstLetter, getToLocalStorage } from "../../Library/Utils";

import textResource from "./Language.json";
import En from "./en.json";
import De from "./de.json";

export function convertText(key: any) {
  const language =
    getToLocalStorage("language") !== "" &&
      getToLocalStorage("language") !== null
      ? getToLocalStorage("language")
      : "En";
  if (capitalizeFirstLetter(language) === "De") return De[`${key}` as keyof typeof De];
  if (capitalizeFirstLetter(language) === "En") return En[`${key}` as keyof typeof En];

  return textResource[`${key}${language}` as keyof typeof textResource];
}
